import React from "react";
import { formatNumber2 } from "utils/currencyFormat";
import { tinhTangTruong, dinhDangSo } from "../LoiNhuan/periodUtils";

const MAU_TANG = "#00B69B";
const MAU_GIAM = "#FF5170";
const MAU_CHU = "#2B335E";
const MAU_KY_NAY = "#2a78d6";
const MAU_KY_TRUOC = "#FFA23A";

/** Nền nhạt cùng tông với màu icon (#2a78d6 -> rgba(42,120,214,0.12)) */
const nenNhat = (mau) => {
  const r = parseInt(mau.slice(1, 3), 16);
  const g = parseInt(mau.slice(3, 5), 16);
  const b = parseInt(mau.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, 0.12)`;
};

const customStyles = `
  .khgt-tong-quan {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
  }
  .khgt-o {
      flex: 1 1 240px;
      min-width: 0;
      border: 1px solid #d1d3e2;
      border-radius: 12px;
      background-color: #fff;
      box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15);
      padding: 14px 16px;
      display: flex;
      align-items: flex-start;
      gap: 12px;
  }
  .khgt-o .khgt-icon {
      flex-shrink: 0;
      width: 60px;
      height: 60px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      margin-top: 1.5rem;
  }
  .khgt-o .khgt-noi-dung {
      flex: 1;
      min-width: 0;
  }
  .khgt-o .khgt-nhan {
      font-size: 13px;
      font-weight: 700;
      color: ${MAU_CHU};
      text-transform: uppercase;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
  }
  .khgt-o .khgt-ngay {
      font-size: 11px;
      color: #b1b3c4;
      margin-top: 2px;
      min-height: 16px;
  }
  .khgt-o .khgt-so {
      font-size: 30px;
      font-weight: 700;
      color: ${MAU_CHU};
      line-height: 1.2;
      margin-top: 6px;
  }
  .khgt-o .khgt-phu {
      font-size: 13px;
      font-weight: 700;
      margin-top: 4px;
      min-height: 20px;
  }
`;

export const SummaryKhachHangGiaTang = ({
  tongKyNay,
  tongKyTruoc,
  kyNay,
  kyTruoc,
  loading,
}) => {
  const { chenhLech, tyLe } = tinhTangTruong(tongKyNay, tongKyTruoc);
  const laTang = chenhLech > 0;
  const laGiam = chenhLech < 0;
  const mauChenhLech = laTang ? MAU_TANG : laGiam ? MAU_GIAM : MAU_CHU;

  const chuTyLe =
    tyLe === null
      ? "Kỳ trước chưa có khách hàng mới"
      : `${laTang ? "▲" : laGiam ? "▼" : ""} ${dinhDangSo(
          Math.abs(tyLe),
        )}% so với ${(kyTruoc && kyTruoc.nhan) || "kỳ trước"}`.trim();

  const renderO = (
    nhan,
    khoangNgay,
    giaTri,
    chuPhu,
    mauPhu,
    mauSo,
    icon,
    mauIcon,
  ) => (
    <div className="khgt-o">
      <div
        className="khgt-icon"
        style={{ color: mauIcon, backgroundColor: nenNhat(mauIcon) }}
      >
        <i className={icon}></i>
      </div>
      <div className="khgt-noi-dung">
        <div className="khgt-nhan">{nhan}</div>
        <div className="khgt-ngay">{khoangNgay || ""}</div>
        <div className="khgt-so" style={mauSo ? { color: mauSo } : {}}>
          {loading ? (
            <div className="spinner-border text-primary" role="status"></div>
          ) : (
            giaTri
          )}
        </div>
        <div className="khgt-phu" style={{ color: mauPhu || "#858796" }}>
          {loading ? "" : chuPhu}
        </div>
      </div>
    </div>
  );

  const iconTangThem = laTang
    ? "fas fa-arrow-up"
    : laGiam
      ? "fas fa-arrow-down"
      : "fas fa-minus";

  return (
    <div className="p-1">
      <style>{customStyles}</style>
      <div className="khgt-tong-quan">
        {renderO(
          "Tổng khách hàng mới",
          kyNay && kyNay.khoangNgay,
          formatNumber2(tongKyNay),
          chuTyLe,
          tyLe === null ? "#858796" : mauChenhLech,
          null,
          "fas fa-user-plus",
          MAU_KY_NAY,
        )}
        {renderO(
          "Khách hàng mới kỳ trước",
          kyTruoc && kyTruoc.khoangNgay,
          formatNumber2(tongKyTruoc),
          (kyTruoc && kyTruoc.nhan) || "Kỳ so sánh",
          null,
          null,
          "fas fa-user-clock",
          MAU_KY_TRUOC,
        )}
        {renderO(
          "Tăng thêm",
          "So với kỳ so sánh",
          `${chenhLech > 0 ? "+" : chenhLech < 0 ? "-" : ""}${formatNumber2(
            Math.abs(chenhLech),
          )}`,
          chenhLech === 0
            ? "Không đổi so với kỳ trước"
            : `${laTang ? "Tăng" : "Giảm"} ${formatNumber2(
                Math.abs(chenhLech),
              )} khách hàng`,
          mauChenhLech,
          mauChenhLech,
          iconTangThem,
          mauChenhLech,
        )}
      </div>
    </div>
  );
};
